import { useEffect } from "react";
import {
  Box,
  Heading,
  Text,
  Flex,
  Image,
  Button,
  Icon,
} from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";

import { extractDatePart } from "../core/utils";
import LogoIcon from "../assets/images/logoIcon.png";
import Default1 from "../assets/images/default1.png";
import SuccessBg from "../assets/images/successBg.png";

export const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { firstName, lastName, serviceName, date, startTime } =
    location.state || {};

  // If no state is present, go back
  useEffect(() => {
    if (!location.state) {
      navigate(-1);
    }
  }, [location.state, navigate]);

  const statusContainer = {
    borderRadius: "4px",
    backgroundColor: "#DBF1F2",
    py: "3px",
    px: "8px",
  };

  return (
    <Box>
      <Flex
        boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
        py="12px"
        px={{ base: "20px", md: "10%" }}
        align={"center"}
        justify={"space-between"}
      >
        <Image src={LogoIcon} alt="Book-d Logo" h={"32px"} w="19px" />
      </Flex>

      <Box px={{ base: "20px", md: "10%" }} py="24px">
        <Flex
          gap={"6px"}
          align={"center"}
          mb="32px"
          display={{ base: "none", md: "flex" }}
        >
          <Text fontSize={"16px"} color={"#4F4F51"} lineHeight={"24px"}>
            Home
          </Text>

          <Icon fontSize={"20px"} color={"#19202D"}>
            <IoIosArrowForward />
          </Icon>

          <Text fontSize={"16px"} color={"#4F4F51"} lineHeight={"24px"}>
            Services
          </Text>

          <Icon fontSize={"20px"} color={"#19202D"}>
            <IoIosArrowForward />
          </Icon>

          <Text fontSize={"16px"} color={"#FF762C"} lineHeight={"24px"}>
            Confirmation
          </Text>
        </Flex>

        <Flex
          flexDir={"column"}
          align={"center"}
          justify={"center"}
          backgroundImage={`url(${SuccessBg})`}
          backgroundRepeat="no-repeat"
          justifySelf={"center"}
          backgroundSize="contain"
          maxW={"300px"}
          h="360px"
          gap={"4px"}
          px={"44px"}
        >
          <Image
            src={Default1}
            w={"96px"}
            h={"96px"}
            borderRadius={"48px"}
            zIndex={3}
          />

          <Heading fontSize={"22px"} color={"#19202D"}>
            {firstName} {lastName?.charAt(0)}.
          </Heading>

          <Flex gap={"5px"} flexWrap={"wrap"} justify={"center"}>
            <Box sx={statusContainer}>
              <Text fontSize={"14px"} fontWeight={700} color={"#267684"}>
                {date && extractDatePart(date, "date")}
              </Text>
            </Box>

            <Box sx={statusContainer}>
              <Text fontSize={"14px"} fontWeight={700} color={"#267684"}>
                {startTime &&
                  extractDatePart(`1970-01-01T${startTime}:00`, "time")}
              </Text>
            </Box>

            <Box sx={statusContainer}>
              <Text fontSize={"14px"} color={"#267684"}>
                {serviceName}
              </Text>
            </Box>
          </Flex>
        </Flex>

        <Box mt="32px">
          <Text
            fontSize="18px"
            color="#19202D"
            fontWeight={700}
            textAlign={"center"}
          >
            Booking Confirmed!
          </Text>

          <Text fontSize={"14px"} color="#19202D" textAlign={"center"}>
            Your can manage your booking or reschedule your appointment from the
            Book-d app.{" "}
          </Text>
        </Box>

        <Flex mt="32px" gap={"4px"} justify={"center"}>
          <Icon fontSize={"24px"} color={"#D9ED8C"}>
            <svg
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 20H10C10 21.1 9.1 22 8 22C6.9 22 6 21.1 6 20ZM4 19H12V17H4V19ZM15.5 9.5C15.5 13.32 12.84 15.36 11.73 16H4.27C3.16 15.36 0.5 13.32 0.5 9.5C0.5 5.36 3.86 2 8 2C12.14 2 15.5 5.36 15.5 9.5ZM20.37 7.37L19 8L20.37 8.63L21 10L21.63 8.63L23 8L21.63 7.37L21 6L20.37 7.37ZM18 6L18.94 3.94L21 3L18.94 2.06L18 0L17.06 2.06L15 3L17.06 3.94L18 6Z"
                fill="#D9ED8C"
              />
            </svg>
          </Icon>

          <Text
            fontSize={"14px"}
            color="#191C21CC"
            opacity={0.8}
            fontWeight={600}
          >
            Tip: Use the same email as your booking to sign up
          </Text>
        </Flex>

        <Flex justifySelf={{ base: undefined, md: "center" }}>
          <Button
            bg={"#FF8E3C"}
            _hover={{ bg: "#FF8E3C" }}
            mt="32px"
            borderRadius={"30px"}
            color={"white"}
            w={{ base: "100%", md: "300px" }}
            h="58px"
            fontSize={"17px"}
            fontFamily={"RedHatDisplay-Bold"}
            onClick={() => navigate("/")}
          >
            Manage Booking
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};
